import React from 'react';
import './config/Fire';
import 'antd/dist/antd.min.css';
import './assets/style/style.css';
import './assets/js/script.js'
import Routers from './Routers';

const App = () => <Routers />;

export default App;
